import { axiosInstance } from '../../api';
const BASE_PATH = '/billing';


//get billing Details API Call
export let getBillingDetails = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_billing_details')
        return value;
    } catch (error) {
        return error
    }
}

//post billing Details API Call
export let setBillingDetails = async (phone,address,city,country,province,postalCode) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_billing_details',{
            street_address: address,
            city: city,
            country: country,
            province: province,
            postal_code: postalCode,
            phone_no: phone
        })
        return value;
    } catch (error) {
        return error
    }
}

//initialize payment API Call
export let initializePayment = async (billID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/init_payment', {
            bill_id: billID
        })
        return value;
    } catch (error) {
        return error
    }
}

//check payment status API Call
export let checkPaymentStatus = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/check_payment_status');
        return value;
    } catch (error) {
        return error
    }
}
